interface DownloadBlobProps {
  blob: Blob;
  filename: string;
}

const downloadBlob = ({ blob, filename }: DownloadBlobProps) => {
  let url: string | undefined;
  try {
    const link = document.createElement('a');
    link.download = filename;
    url = window.URL.createObjectURL(blob);
    link.href = url;
    link.click();
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error(`Download file error: ${ex}`);
    return false;
  } finally {
    window.setTimeout(() => {
      if (url) {
        window.URL.revokeObjectURL(url);
      }
    }, 0);
  }
  return true;
};

export default downloadBlob;
